import { useTranslation } from "react-i18next"
import { useFragment } from "react-relay"
import { ArrowSquareOut, PencilSimple } from "@phosphor-icons/react"
import { ListItem, ListText } from "@/components/ui/list"
import { Tag } from "@/components/ui/tag"
import { cn } from "@/lib/utils"
import { useCareProviderWithOrigin } from "@/modules/care-provider/services/useCareProviderWithOrigin"
import { combineCareProviderTitle } from "@/modules/care-provider/utils/combine-care-provider-title"
import { DocumentProps } from "@/modules/patients/detail/progress-note/types/document"
import { useConcludeDialogStoreContext } from "@/modules/patients/detail/store/useConcludeDialogStore"
import { ChPsychologicalTherapyDrawer } from "@/modules/patients/detail/therapy-prescription/ch/ch-psychological-psychotherapy-drawer"
import { chPsychologicalPsychoTherapyFragment$key } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/chPsychologicalPsychoTherapyFragment.graphql"
import { chPsychologicalPsychoTherapyFragment } from "@/modules/patients/detail/therapy-prescription/ch/services/chPsychologicalPsychoTherapyFragment"
import { usePsychologicalPsytherapyStoreContext } from "@/modules/patients/detail/therapy-prescription/ch/store/usePsychologicalPsytherapyStore"
import { useDrawerStore } from "@/stores/useDrawerStore"

export const PsychologicalPsychotherapyIcon = ({ isSelected }: { isSelected?: boolean }) => {
  return (
    <svg className="h-6 w-6 shrink-0" viewBox="0 0 24 25" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Vector"
        d="M11.1096 14.2019L11.1808 14.8769C11.191 14.9974 11.2383 15.0961 11.3225 15.173C11.4068 15.25 11.5101 15.2884 11.6327 15.2884H12.3673C12.4898 15.2884 12.5932 15.25 12.6775 15.173C12.7617 15.0961 12.8089 14.9974 12.8192 14.8769L12.8904 14.2019C13.0878 14.1519 13.2727 14.0791 13.4452 13.9836C13.6176 13.8881 13.7647 13.7698 13.8865 13.6288L14.4923 13.9057C14.5961 13.9557 14.7026 13.9658 14.8118 13.936C14.921 13.9061 15.0068 13.839 15.0692 13.7346L15.4365 13.1019C15.4968 12.9981 15.5154 12.8925 15.4926 12.7853C15.4697 12.6781 15.4125 12.5862 15.3211 12.5096L14.7769 12.1115C14.8487 11.9077 14.8846 11.7038 14.8846 11.5C14.8846 11.2961 14.8487 11.0923 14.7769 10.8884L15.3211 10.4904C15.4125 10.4138 15.4697 10.3219 15.4926 10.2147C15.5154 10.1074 15.4968 10.0019 15.4365 9.89805L15.0692 9.26538C15.0068 9.16094 14.921 9.09381 14.8118 9.06398C14.7026 9.03414 14.5961 9.04423 14.4923 9.09423L13.8865 9.37115C13.7647 9.23012 13.6176 9.11184 13.4452 9.01633C13.2727 8.92081 13.0878 8.84805 12.8904 8.79805L12.8192 8.12308C12.8089 8.00256 12.7617 7.90384 12.6775 7.82693C12.5932 7.74999 12.4898 7.71153 12.3673 7.71153H11.6327C11.5101 7.71153 11.4068 7.74999 11.3225 7.82693C11.2383 7.90384 11.191 8.00256 11.1808 8.12308L11.1096 8.79805C10.9122 8.84805 10.7272 8.92081 10.5548 9.01633C10.3824 9.11184 10.2352 9.23012 10.1134 9.37115L9.50768 9.09423C9.40383 9.04423 9.29731 9.03414 9.18813 9.06398C9.07894 9.09381 8.99315 9.16094 8.93075 9.26538L8.56345 9.89805C8.5032 10.0019 8.48451 10.1074 8.50738 10.2147C8.53024 10.3219 8.5874 10.4138 8.67885 10.4904L9.22308 10.8884C9.15128 11.0923 9.11538 11.2961 9.11538 11.5C9.11538 11.7038 9.15128 11.9077 9.22308 12.1115L8.67885 12.5096C8.5874 12.5862 8.53024 12.6781 8.50738 12.7853C8.48451 12.8925 8.5032 12.9981 8.56345 13.1019L8.93075 13.7346C8.99315 13.839 9.07894 13.9061 9.18813 13.936C9.29731 13.9658 9.40383 13.9557 9.50768 13.9057L10.1134 13.6288C10.2352 13.7698 10.3824 13.8881 10.5548 13.9836C10.7272 14.0791 10.9122 14.1519 11.1096 14.2019ZM11.9994 13.1827C11.5318 13.1827 11.1346 13.019 10.8077 12.6917C10.4807 12.3644 10.3173 11.967 10.3173 11.4994C10.3173 11.0318 10.4809 10.6346 10.8082 10.3077C11.1355 9.98073 11.533 9.81728 12.0006 9.81728C12.4681 9.81728 12.8654 9.98093 13.1923 10.3082C13.5192 10.6355 13.6827 11.033 13.6827 11.5006C13.6827 11.9681 13.519 12.3654 13.1917 12.6923C12.8644 13.0192 12.467 13.1827 11.9994 13.1827ZM6.5 17.9692C5.55 17.1025 4.8125 16.1093 4.2875 14.9894C3.7625 13.8695 3.5 12.7041 3.5 11.493C3.5 9.13386 4.32639 7.12857 5.97918 5.47715C7.63194 3.82572 9.63888 3 12 3C13.9423 3 15.6791 3.58045 17.2105 4.74135C18.7419 5.90225 19.7365 7.40833 20.1942 9.2596L21.3626 13.8742C21.4375 14.1593 21.3845 14.4182 21.2038 14.6509C21.023 14.8836 20.782 15 20.4807 15H18.5V18.1923C18.5 18.6894 18.3229 19.1149 17.9689 19.4689C17.6149 19.8229 17.1894 20 16.6922 20H14.5V21.25C14.5 21.4625 14.428 21.6406 14.2842 21.7843C14.1404 21.9281 13.9622 22 13.7496 22C13.537 22 13.3589 21.9281 13.2154 21.7843C13.0718 21.6406 13 21.4625 13 21.25V19.4086C13 19.1477 13.0866 18.9311 13.2598 18.7586C13.4331 18.5862 13.6477 18.5 13.9038 18.5H16.6922C16.782 18.5 16.8557 18.4711 16.9134 18.4134C16.9711 18.3557 17 18.282 17 18.1923V14.4038C17 14.1477 17.0866 13.9331 17.2598 13.7598C17.4331 13.5866 17.6477 13.5 17.9038 13.5H19.7L18.75 9.62498C18.3666 8.10189 17.5468 6.86696 16.2904 5.92018C15.034 4.97338 13.6038 4.49998 12 4.49998C10.0666 4.49998 8.41664 5.17591 7.04998 6.52778C5.68331 7.87964 4.99997 9.52358 4.99997 11.4596C4.99997 12.458 5.20414 13.4064 5.61247 14.3049C6.02081 15.2034 6.59998 16.0021 7.34998 16.701L7.99998 17.3V21.25C7.99998 21.4625 7.92807 21.6406 7.78425 21.7843C7.64045 21.9281 7.46225 22 7.24965 22C7.03707 22 6.85898 21.9281 6.7154 21.7843C6.5718 21.6406 6.5 21.4625 6.5 21.25V17.9692Z"
        className={isSelected ? "fill-on-primary-surface" : "fill-on-surface-subdued"}
      />
    </svg>
  )
}

interface PsychologicalPsychoTherapyProps extends DocumentProps {
  psychologicalPsychoTherapyRef: chPsychologicalPsychoTherapyFragment$key
  progressNoteId: string
}

const PsychologicalPsychoTherapy = ({
  psychologicalPsychoTherapyRef,
  progressNoteId,
  isEditable = true,
  isConclusion,
  isSigned,
  isSent,
  onSelect,
}: PsychologicalPsychoTherapyProps) => {
  const { t } = useTranslation()
  const { id, healthcareProviderId } =
    useFragment(chPsychologicalPsychoTherapyFragment, psychologicalPsychoTherapyRef) ?? {}
  const setPsychologicalPsytherapy = usePsychologicalPsytherapyStoreContext((state) => state.setPsychologicalPsytherapy)

  const selectedDocumentId = useConcludeDialogStoreContext((state) => state.selectedDocument?.id)
  const openDrawer = useDrawerStore((state) => state.openDrawer)
  const isSelected = isConclusion && selectedDocumentId === id

  const triggeredValidation = useConcludeDialogStoreContext((state) => state.triggeredValidation)

  const careProvider = useCareProviderWithOrigin(healthcareProviderId)

  const heathcareProviderName = combineCareProviderTitle({
    businessName: careProvider?.businessName,
    title: careProvider?.title,
    firstName: careProvider?.firstName,
    lastName: careProvider?.lastName,
  })

  return (
    <ListItem
      className={cn(
        "group hover:bg-surface-hovered relative flex items-center hover:cursor-pointer",
        isSelected && "bg-primary-surface hover:bg-primary-surface-hovered active:bg-primary-surface-pressed",
        !isEditable && !isConclusion && !isSent && "cursor-auto!",
      )}
      data-testid="psychological-psychotherapy-document-item"
      onClick={() => {
        if (!isEditable) {
          onSelect()
          return
        }
        setPsychologicalPsytherapy(id, psychologicalPsychoTherapyRef)
        openDrawer(() => <ChPsychologicalTherapyDrawer progressNoteId={progressNoteId} />, "PsychologicalTherapyDrawer")
      }}>
      <PsychologicalPsychotherapyIcon isSelected={isSelected} />
      <div className="ml-2 min-w-0">
        <ListText className={cn(isSelected && "text-on-primary-surface")}>
          {t("patient.therapyPrescription.therapyPrescriptionPsychologicalPsychotherapy")}
        </ListText>
        <ListText
          data-testid="psychological-psychotherapy-details"
          variant="secondary"
          className={cn("truncate", isSelected && "text-on-primary-surface")}>
          {heathcareProviderName}
        </ListText>
      </div>
      {isEditable && (
        <div className="absolute right-2 ml-auto hidden group-hover:block">
          <div className="hover:bg-surface-hovered p-2 hover:rounded-full hover:p-2">
            <PencilSimple className="text-on-surface-subdued" data-testid="psychological-psychotherapy-edit-button" />
          </div>
        </div>
      )}
      {!isConclusion && isSent && (
        <div className="absolute right-2 ml-auto hidden group-hover:block">
          <div className="hover:bg-surface-hovered p-2 hover:rounded-full hover:p-2">
            <ArrowSquareOut
              className="text-on-surface-subdued"
              data-testid="psychological-psychotherapy-document-button"
            />
          </div>
        </div>
      )}
      {isConclusion && (triggeredValidation || isSigned) && (
        <Tag
          className="ml-auto group-hover:hidden"
          type={isSigned ? "success" : "critical"}
          label={isSigned ? t("patient.conclude.signed") : t("patient.conclude.signThis")}
        />
      )}
    </ListItem>
  )
}

export { PsychologicalPsychoTherapy }
